export const quantumHardwareProducts = [
  // {
  //     title: "Qsleeve",
  //     name: "Qsleeve",
  //     image: require("../../src/Images/Q-SLEEVE LOGO.png"),
  //     headline: "Quantum-Safe Data Protection Made Easy",
  //     content: "explore more",

  // },
  // {
  //     title: "ChecQ",
  //     name: "",
  //     image: require("../../src/Images/CHEC-Q.png"),
  //     headline: "Quantum Vulnerability Scanning Tool",
  //     content: "ChecQ addresses emerging threats posed by quantum computing, detecting cryptographic vulnerabilities in websites and software. Institutions can proactively safeguard systems and critical infrastructure."
  // },
  // {
  //     title: "QMag",
  //     name: "",
  //     image: require("../../src/Images/Q-Mag.png"),
  //     headline: "Rubidium based Magnetometer for Bio-sensing Application",
  //     content: "The invention is a Spin Exchange Relaxation-Free (SERF) Alkali Metal Magnetometer optimized for bio-sensing applications like Magnetoencephalography (MEG), Magnetocardiography (MCG), and MRI. It features a Vertical External Cavity Surface Emitting Laser (VCSEL) with dual coaxial beams for precise polarized light manipulation."
  // },
  {
    title: "Q-Memory",
    name: "QuantumMemory",
    image: require("../../src/Images/Products/QMEMORY_WN.png"),
    marketready: false,
    headline: "Rb based warm vapor cell.",
    content:
      "An educational kit to explore Quantum Memory, highlighting its role in Quantum Storage, long-distance entanglement, and secure Quantum Key Distribution. Ideal for learning EIT and storage of light",
    description:
      "A compact, industrial quantum optics system for generation, storage, and retrieval of photonic pulses and polarization qubits using warm ⁸⁷Rb vapor based on Electromagnetically Induced Transparency (EIT). Fully functional at room temperature with integrated laser control, quantum storage upto 35 micro-second, and detection — ideal for synchronisation in quantum networks, repeaters, Quantum Radar, Quantum Sensing and secure communication.",
  },
  {
    title: "EPS-QKD",
    name: "EPSQKD",
    image: require("../../src/Images/Products/EPSQKD_WN.png"),
    marketready: false,
    headline: "Quantum Key Distribution",
    content:
      "An interactive kit for exploring entanglement-based Quantum Key Distribution, Bell's Inequality, single-photon sources, and more - all in one system",
    description:
      "A rack-mountable industrial QKD platform using a high-brightness polarization-entangled photon source for secure key distribution with device-independent security advantages. It implements BBM92 protocol, enabling strong eavesdropping detection through Bell inequality violation and enhanced protection against side-channel attacks. Designed for real-world deploymen in critical infrastructure, finance, government, and data centres, supporting benchmarking of entanglemen performance and integration into quantum secure networks. Compact, fibre-compatible, and stable, it delivers reliable secret key rates over distance while paving the way for future quantum repeaters and networks.",
  },
  {
    title: "Q-Biosensor",
    name: "QuantumBiosernsor",
    image: require("../../src/Images/Products/QSENSING_WN.png"),
    marketready: false,
    headline: "Optically Pumped Magnetometer based Quantum Biosensor",
    content:
      "A non-invasive sensor that can “listen” to the body’s tiny magnetic signals from the brain, heart, and muscles. It enables early detection of diseases by capturing signals that traditional systems struggle to detect",
    description:
      "The quantum biosensor uses optically pumped magnetometers (OPMs) to detect ultra-weak biomagnetic fields generated by neural and cardiac activity. It leverages quantum properties of alkali atoms (like rubidium) and laser-based optical pumping to achieve high sensitivity (nT to fT range) at room temperature. Unlike SQUID systems, it eliminates cryogenic cooling, enabling compact, wearable, and closer-to-body measurements with improved spatial resolution. This makes it highly suitable for applications like magnetoencephalography (MEG), magnetocardiography (MCG), and next-gen biomedical diagnostics.",
  },
  {
    title: "ECDL",
    name: "ECDL",
    image: require("../../src/Images/Products/ECDL_WN.png"),
    marketready: false,
    headline: "Narrow Linewidth External Cavity Diode Laser",
    content:
      "A highly precise laser system that produces extremely stable and narrow light frequencies for advanced experiments. It acts as a “tunable light source” used to control and study atoms, ions, and quantum systems",
    description:
      "The ECDL is a narrow-linewidth laser system with external cavity feedback, enabling precise frequency tuning and stability (~kHz–MHz range). It integrates ultra-low-noise current and temperature controllers along with piezo-based tuning for mode-hop-free scanning across atomic transitions. The system supports frequency locking via spectroscopy or reference cavities, making it ideal for quantum optics and metrology applications. With customizable wavelengths (UV–IR) and high output power, it serves as a core component in quantum sensing, communication, and computing setups.",
  },
];

export const quantumSoftwareProducts = [
  {
    title: "Q-Forte",
    name: "QForte",
    image: require("../../src/Images/Products/QFORTE_WN.png"),
    marketready: true,
    headline: "Orchestration Quantum Assured InfoSec Platform",
    content:
      "Quantum Security Assurance Product Suite designed to elevate the Information Security posture of enterprises to cutting-edge Post Quantum Cryptography confidence level",
    description:
      "With focus on robust quantum level security assurance with crypto-agility, this product suite consists of a Quantum Vulnerability Assessment Tool (ChecQ-AI), a Quantum Safe VPN solution (Q-Sleeve) and cloud-based scalable Quantum Random Number Generators (QuRNG) ensuring full spectrum enhancement of the organisation’s security infrastructure to PQC standards.",
  },
  {
    title: "QubitIQ",
    name: "QubitIQ",
    image: require("../../src/Images/Products/QUBITIQ_WN.png"),
    marketready: false,
    headline: "Generalized Quantum Algorithm Development Accelerator ",
    content:
      "Enables organizations with AI-driven Quantum Intelligence, accelerating optimal Quantum Algorithm development at scale",
    description:
      "A unified platform that seamlessly integrates classical, quantum, and hybrid computing, enabling efficient end-to-end workflows. It leverages AI-driven recommendations for intelligent encoding and optimized quantum circuits, accelerating algorithm development. Designed to be scalable and problem-agnostic, it adapts effortlessly across diverse domains and computational challenges. By simplifying enterprise adoption, it drives real-world impact across industries such as finance, logistics, energy, pharma, and manufacturing.",
  },
  {
    title: "Q-Cluster",
    name: "QCluster",
    image: require("../../src/Images/Products/QCLUSTER_WN.png"),
    marketready: false,
    headline: "Scalable Gate-based Quantum Computing Simulator",
    content:
      "Driving the future of quantum innovation through accelerated learning, advanced algorithm development, and reliable quantum processor performance modeling",
    description:
      "Starting from the preliminary learning of Quantum algorithms and its implementation on scalable qubits of quantum computers; to deeper understanding of how quantum states evolve with noise & approximately simulating its effects on quantum algorithms — Q-Cluster, covers the complete spectrum of Quantum Information Processing (QIP) paradigm. With the option of integrating multiple noise density matrices, Q-Cluster evolves into a high-fidelity simulator for approximating the Noisy Intermediate-Scale Quantum (NISQ) era and beyond.",
  },
  {
    title: "QNTSim",
    name: "QNTSim",
    image: require("../../src/Images/Products/QNTSIM_WN.png"),
    marketready: false,
    headline: "Quantum Network Simulator",
    content:
      "Explore the building blocks of the quantum internet through configurable simulations of quantum communication protocols",
    description:
      "From the foundational concepts of quantum communication to advanced exploration of networked QKD protocols, QNTSim covers the full spectrum of quantum networking. It enables users to understand how quantum information is generated, transmitted, and preserved across distributed systems while simulating real-world network conditions and constraints. Through configurable architectures and protocol-level experimentation, QNTSim provides deep insights into the behavior of quantum networks.",
  },
];

export const quantumRNDProducts = [
  {
    title: "Quantum Repeater",
    name: "QuantumRepeater",
    image: "",
    marketready: false,
    headline: "Quantum Repeater",
    content: "",
    description:
      "From the foundational concepts of quantum communication to advanced exploration of networked QKD protocols, QNTSim covers the full spectrum of quantum networking. It enables users to understand how quantum information is generated, transmitted, and preserved across distributed systems while simulating real-world network conditions and cThe Quantum Repeater enables long-distance quantum communication by distributing high-fidelity entanglement across segmented links. It integrates quantum memories, entangled photon sources, and entanglement swapping for reliable transmission beyond 100 km limits. Advanced purification and error correction ensure robust and scalable performance. Designed for telecom compatibility and modular deployment, it forms the backbone of secure global quantum networks.onstraints. Through configurable architectures and protocol-level experimentation, QNTSim provides deep insights into the behavior of quantum networks.",
  },
  {
    title: "Quantum Gravimeter",
    name: "QuantumGravimeter",
    image: "",
    marketready: false,
    headline: "Quantum Gravimeter",
    content: "",
    description:
      "The Quantum Gravimeter uses laser-cooled Rubidium atoms and atom interferometry to measure gravitational acceleration with extreme precision. By tracking phase shifts in atomic wave packets during free fall, it provides absolute, calibration-free measurements. It offers superior stability and sensitivity compared to classical gravimeters. Built for real-world deployment, it supports applications in geophysics, navigation, and infrastructure monitoring.",
  },
  {
    title: "Rydberg Sensor",
    name: "RydbergSensor",
    image: "",
    marketready: false,
    headline: "Rydberg Sensor",
    content: "",
    description:
      "The Rydberg Sensor leverages highly excited atomic states to detect RF and microwave electric fields with exceptional sensitivity. Using optical readout techniques like EIT, it provides direct, SI-traceable measurements without external calibration. It supports ultra-wide bandwidth from kHz to THz with high precision. Compact and room-temperature compatible, it is ideal for communications, defense, and advanced sensing applications.",
  },
];



export const patentproductsdata = [
  // {
  //     id: 1,
  //     name: "Quantum-Resistant Cryptographic System for Secure Communication",
  //     img: require("../../src/Images/Q-SLEEVE.png"),
  //     content: "With the advent of Quantum algorithms and processors the eminent threat to our communication security paradigm is looming over our heads. The term Y2Q, more conveniently called Years to Quantum or the Q-DAY is not a distant future to us. This patent drives the development of our product Q-Sleeve which is based on the Post Quantum Cryptography algorithms which are considered to be quantum resistant. This will work above the current internet system within the organization and keep the data encrypted facilitating the security for Post Quantum Era (PQE) as well. By enabling this mechanism on an end user communication system will ensure that the data will still remain encrypted even if the public cryptosystem gets broken.",
  //     patent: "202341046359",
  // },
  // {
  //     id: 2,
  //     name: "An Intelligent System for Quantum Data Processing and Algorithm Recommendation",
  //     img: require("../../src/Images/QUBIT-IQ.png"),
  //     content: "We propose an intelligent software system that harnesses the power of machine intelligence and quantum computing to tackle the challenges of multi-modal data processing. This patent drives the development of our product QubitIQ that will offer invaluable guidance by mapping each suggested data encoding template to the most suitable quantum algorithms, empowering researcher’s and developers to leverage quantum computing effectively in solving real-world challenges.",
  //     patent: "202341052490",
  // },
  // {
  //     id: 3,
  //     name: "Rubidium based Magnetometer for Bio-sensing Application",
  //     img: require("../../src/Images/Q-Mag logo.png"),
  //     content: "The invention presents a Spin Exchange Relaxation-Free (SERF)-based Alkali Metal Magnetometer optimized for bio-sensing applications, notably in Magneto encephalography (MEG), Magneto cardiography (MCG), and Magnetic Resonance Imaging (MRI). The device utilizes a Vertical External Cavity Surface Emitting Laser (VCSEL) emitting dual coaxial beams, enabling precise manipulation of polarized light.",
  //     patent: "202441028401",
  // }
];

export const ipdata = [
  // {
  //     id: 1,
  //     name: "Quantum Sensors Technologies",
  //     img: require("../../src/Images/quantum sensor logo.png"),
  //     content: "Where quantum effects such as entanglement or superposition are exploited in the undertaking of high-resolution of physical parameters.",
  // },
  // {
  //     id: 2,
  //     name: "Quantum Timing And Atomic Clocks",
  //     img: require("../../src/Images/atomic clock logo.png"),
  //     content: "Methods and devices for time keeping which use electron transition frequency or other atomic scale properties as a frequency standard for timekeeping.",
  // },
];
